import { render, staticRenderFns } from "./site-details.vue?vue&type=template&id=38e090da&"
import script from "./site-details.vue?vue&type=script&lang=ts&"
export * from "./site-details.vue?vue&type=script&lang=ts&"
import style0 from "./site-details.vue?vue&type=style&index=0&id=38e090da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports